//Styles
import "./BodyZapSignThankScreen.css";

const BodyZapSignThankScreen = () => {
  return (
    <section className="not-found-page-section">
      <div className="not-found-page-subcontainer">
        <div className="info-thank-container">
          <h1>Gracias por completar la firma de su solicitud de crédito.</h1>
          <p>
            Para realizar el pago de su primera cuota, haga clic en el siguiente
            botón. Será redirigido a nuestro portal de clientes.
          </p>
          <a
            className="client-button"
            href="https://pagos.crediseguro.co/auth/login"
          >
            Portal Clientes
          </a>
          <img
            src="https://d2bkevvrv5np7q.cloudfront.net/page/crediseguro-page/thanks-page/thanks-deco-img.webp"
            className="thanks-deco-img"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default BodyZapSignThankScreen;
